import { ready, emailRegex } from "./utils";

ready(() => {
  const settingsForm = document.querySelector('#settings-form');
  if (!settingsForm) {
    return;
  }

  const userPasswordEl = document.querySelector("#user_password");
  const userPasswordConfirmationEl = document.querySelector("#user_password_confirmation");
  // Client side validations for form fields
  let validations = [
    {selector: '#user_name', validator: val => (val === 'Guest' || Boolean(val.match(/^[^ ]+( [^ ]+)+$/)))},
    {selector: '#user_email', validator: val => Boolean(val.match(emailRegex))},
  ]

  if (userPasswordEl) {
    validations.push({
      selector: '#user_password',
      validator: val => (val.length == 0 || val.length >= 6)
    });
  }
  if (userPasswordConfirmationEl) {
    validations.push({
      selector: '#user_password_confirmation',
      validator: val => val === userPasswordEl.value
    });
  }

  settingsForm.addEventListener('submit', e => {
    e.preventDefault();
    const form = e.target;

    // Do some simple client side validation
    let valid = true;
    validations.forEach(obj => {
      const field = document.querySelector(obj.selector);
      if (obj.validator(field.value)) {
        field.nextElementSibling.classList.add('hidden');
      } else {
        field.nextElementSibling.classList.remove('hidden');
        valid = false;
      }
    });
    if (!valid) {
      return;
    }

    form.submit();
  });

  // Photo upload
  const readURL = input => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.addEventListener('load', e => {
        const imgPreview = document.querySelector('#settings-img-preview');
        imgPreview.style.backgroundImage = `url(${e.target.result})`;
      });
      reader.readAsDataURL(input.files[0]);
    }
  };
  const imgUploadField = document.querySelector("#settings-img-upload-field");
  if (imgUploadField) {
    imgUploadField.addEventListener('change', e => {
      readURL(e.target);
    });
  }

  // Resume container
  $('#resume-subscription').on('click', e => {
    e.preventDefault();
    $('#resume-confirm-container').slideDown('fast');
  });
});
